module.exports = __webpack_public_path__ + "img/logo_nmbe.be647f01.png";